import { Box, useTheme } from "@mui/material";
import {
  useEffect,
  useState,
} from "react";
import { tokens } from "../../../../../../../theme";
import Text from "../../../../../../../components/theme/text/Text";
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import { useTranslation } from "react-i18next";
import Subheading from "../../../../../../../components/theme/text/Subheading";
import ButtonSetting from "../../../../../../../components/global/Settings/ButtonSetting";
import StringSetting from "../../../../../../../components/global/Settings/StringSetting";
import SettingsSaveButton from "../../../../../../../components/global/Settings/SettingsSaveButton";
import useManualSettingsSave from "../../../../../../../components/global/Settings/useManualSettingsSave";
import { useGetSettingsQuery, useGetSettingsForRelationQuery } from "../../../../../../../newapi/global/generalApiSlice";
import DropdownSetting from "../../../../../../../components/global/Settings/DropdownSetting";
import { useGetInvoiceProductsSelectQuery } from "../../../../../../../newapi/financial/invoiceProductSlice";
import { useSelector } from "react-redux";
import Shbutton from "../../../../../../../components/theme/buttons/Shbutton";
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import BrandingWatermarkOutlinedIcon from '@mui/icons-material/BrandingWatermarkOutlined';
import MEditBrandedLogin from "../../../../../../../components/global/Modals/MEditBrandedLogin";
import MEditFulfilmentLogo from "../../../../../../../components/global/Modals/MEditFulfilmentLogo";
import PickupCheckoutSetting from "../../../../../../../components/global/Settings/PickupCheckoutSetting";

const GeneralWarehouseSettings = ( props ) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [view, setView] = useState({
    title: 'return_portal',
    icon: <AssignmentReturnIcon />,
  });

  const { data: settings} = useGetSettingsQuery("general");
  const { data: shippingSettings } = useGetSettingsQuery("shipping");
  const { handleChange, hasChanges, isSaving, save } = useManualSettingsSave();

  const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
  const [brandedLoginOpen, setBrandedLoginOpen] = useState(false);
  const [fulfilmentLogoOpen, setFulfilmentLogoOpen] = useState(false);

  
  useEffect(() => {
    props.replaceView({
        ...props.config,
    },);

    return () => {};
  }, []);

  return (
    <Box
      sx={{
        height: 1,
        "@media screen and (max-width: 47.9375em)": {
          paddingTop: 0,
          paddingX: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: 1,
          gap: 2,
          overflow: "hidden",
          background:
            theme.palette.mode === "dark"
              ? colors.grey[300]
              : colors.bg["tertiary"],
          paddingX: 2,
          paddingTop: 4,
          height: 1,
          position: "relative",
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          "@media screen and (max-width: 47.9375em)": {
            paddingTop: 0,
            paddingX: 0,
            background: colors.bg["tertiary"],
          },
          "& .carrier": {
            paddingLeft: 0,
            marginRight: 2,
          },
          "& [aria-label='Carrier']": {
            paddingLeft: 0,
            marginRight: 2,
          },
        }}
      >
        <Box
          sx={{
            paddingX: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {/* The heading is the part that gives way on a phone; the save action has to stay
              reachable there, so the breakpoint sits on the text rather than on the row. */}
          <Box
            sx={{
              "@media screen and (max-width: 47.9375em)": {
                display: "none",
              },
            }}
          >
            <Subheading>{t("core_general_title")}</Subheading>
            {/* <Text light>{t("core_general_subtitle")}</Text> */}
          </Box>
          {isFulfilment && (
            <SettingsSaveButton onClick={save} isLoading={isSaving} disabled={!hasChanges} />
          )}
        </Box>
        
        <Box
          sx={{
            background:
              theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
            flex: 1,
            display:"flex",
            flexDirection:"column",
            gap:2,
            pt:3,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            "@media screen and (max-width: 48em)": {
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[200]
                  : colors.grey[0],
            },
          }}
        >
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              px: 3,
              display:"flex",
              flexDirection:"column",
              gap:3,
            }}
          >
            {isFulfilment && (
              <StringSetting
                manualSave
                onChange={handleChange}
                maxWidth={400}
                settings={settings}
                skey="general_external_knowledgebase"
                placeholder="https://stockhubsupport.zendesk.com/hc/nl"
              />
            )}
            <ButtonSetting
              title={isFulfilment ? "branded_login" : "login_style"}
              subtitle={isFulfilment ? "branded_login_description" : "login_style_description"}
              btnText={t("edit")}
              onClick={() => setBrandedLoginOpen(true)}
              endIcon={<PaletteOutlinedIcon />}
              maxWidth={200}
            />
            <MEditBrandedLogin open={brandedLoginOpen} handleClose={() => setBrandedLoginOpen(false)} />
            <ButtonSetting
              title="fulfilment_logo"
              subtitle="fulfilment_logo_description"
              btnText={t("edit")}
              onClick={() => setFulfilmentLogoOpen(true)}
              endIcon={<BrandingWatermarkOutlinedIcon />}
              maxWidth={200}
            />
            <MEditFulfilmentLogo
              open={fulfilmentLogoOpen}
              handleClose={() => setFulfilmentLogoOpen(false)}
            />
            <PickupCheckoutSetting settings={shippingSettings}/>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default GeneralWarehouseSettings;